<template>
  <v-row justify="end" align="center" class="pagination-wrapper">
    <x-button
      buttonText=""
      :color="$vuetify.theme.themes.light.primary"
      class="pa-0 font700 h-auto"
      textButton
      :disabled="isPrevButtonDisabled"
      :data-test-id="`${dataTestId}__prev-btn`"
      @click="moveToPrev"
    >
      <v-icon slot="button_children" class="double_arrow_left"
        >double_arrow</v-icon
      >
    </x-button>
    <div
      class="positionRelative w-20 date-picker"
      id="chat-date-select-box"
      data-test-id="chat-date-select-box"
    >
      <x-select
        v-model="selectedArchiveId"
        solo
        itemValue="archiveId"
        itemText="displayDate"
        label="Select Date"
        dense
        :data-test-id="`${dataTestId}__select-box`"
        attach="#chat-date-select-box"
        :items="chatDates"
        :disabled="isActionDisabled"
      />
    </div>
    <x-button
      :color="$vuetify.theme.themes.light.primary"
      buttonText=""
      class="pa-0 font700 h-auto"
      textButton
      :disabled="isNextButtonDisabled"
      :data-test-id="`${dataTestId}__next-btn`"
      @click="moveToNext"
    >
      <v-icon slot="button_children">double_arrow</v-icon></x-button
    >
  </v-row>
</template>
<script>
export default {
  name: 'chat-pagination',

  props: {
    chatDates: {
      type: Array
    },
    openInModal: Boolean,
    modalArchiveId: String,
    isActionDisabled: Boolean
  },

  data() {
    return {
      dataTestId: 'chat-pagination'
    };
  },

  computed: {
    selectedArchiveId: {
      get() {
        return this.$route.query.archiveId || this.modalArchiveId || '';
      },
      set(archiveId) {
        /**
         * If open in modal --> handle archive id by prop & events
         * else --> handle archive id by changing route
         */
        if (this.openInModal) {
          this.$emit('updateModalArchiveId', archiveId);
        } else {
          const queryParams = {
            archiveId,
            messageGroupId: this.$route.query?.messageGroupId || ''
          };
          this.$router.replace({ query: queryParams });
        }
      }
    },
    selectedArchiveIdIndex() {
      return this.chatDates.findIndex(
        chatDate => chatDate?.archiveId === this.selectedArchiveId
      );
    },
    isPrevButtonDisabled() {
      return this.isActionDisabled || this.selectedArchiveIdIndex === 0;
    },
    isNextButtonDisabled() {
      return (
        this.isActionDisabled ||
        this.selectedArchiveIdIndex === this.chatDates.length - 1
      );
    }
  },

  methods: {
    moveToNext() {
      this.selectedArchiveId = this.chatDates[
        this.selectedArchiveIdIndex + 1
      ].archiveId;
    },

    moveToPrev() {
      this.selectedArchiveId = this.chatDates[
        this.selectedArchiveIdIndex - 1
      ].archiveId;
    }
  }
};
</script>
<style lang="scss" scoped>
.pagination-wrapper {
  gap: 8px;

  .date-picker {
    flex: unset;
  }
}
.double_arrow_left {
  transform: rotate(180deg);
}
</style>
